import React, {useEffect, useRef} from 'react';
import {Navigate, useOutletContext} from 'react-router-dom';
import SiteHomepage from '../../Homepage/SiteHomepage';

// BAC staff cannot see the customer-facing homepage otherwise: it is rendered
// only for site roles and its feed is scoped to the viewer's own organization.
const HomepageTab = () => {
    const { organization, bacView } = useOutletContext();
    const frameRef = useRef(null);

    // This is a look-only preview: mark the rendered homepage `inert` so none of
    // its inner links/buttons (movie cards, "View details", the trailer modal)
    // can be clicked, focused or keyboard-activated. Set via ref because React 18
    // does not forward the `inert` attribute as a prop.
    useEffect(() => {
        if (frameRef.current) frameRef.current.inert = true;
    });

    if (!bacView) {
        return <Navigate to="../overview" replace />;
    }

    return (
        <div className="homepage-preview">
            <p className="text-white-50">
                <span className="fas fa-eye me-2 text-primary"/>
                Previewing the homepage as {organization.name} users see it. Links are disabled.
            </p>
            <div ref={frameRef} className="preview-frame border-start border-primary">
                <SiteHomepage previewOrganizationId={organization._id} />
            </div>
        </div>
    );
};

export default HomepageTab;
